import React, { useState, useEffect } from "react";
import { client } from "../../src/sanity/client";
import { Link } from "react-router-dom";

function CarsForSalePage() {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const query = `
      *[_type == "car"] {
        title,
        slug {
          current
        },
        images[]{asset->{url}},
        description,
        price,
        year,
        make,
        model,
        isSold
      }
    `;

    client
      .fetch(query)
      .then((data) => {
        setCars(data);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
        console.error("Error fetching cars from Sanity:", error);
      });
  }, []);

  if (loading) {
    return (
      <p className="container mx-auto py-8 text-center">Loading cars...</p>
    );
  }

  if (error) {
    return (
      <p className="container mx-auto py-8 text-center text-red-500">
        Error loading cars: {error.message}
      </p>
    );
  }

  return (
    <div className="container mx-auto py-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {cars.map((car) => (
          <div
            key={car.slug?.current}
            className=" relative bg-white rounded-md shadow-md overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-xl"
          >
            {/* START OF NEW/IMPROVED IMAGE LOGIC */}
            {/* Checks if images array exists, has items, and the first image's asset and URL are available */}
            {car.images &&
            car.images.length > 0 &&
            car.images[0]?.asset?.url ? (
              <img
                src={car.images[0].asset.url}
                alt={car.title || "Car Image"} // Added fallback for alt text
                className="w-full h-48 object-cover rounded-md mb-4"
              />
            ) : (
              // Fallback content if no image is available or valid
              <div className="w-full h-48 bg-gray-200 flex items-center justify-center rounded-md mb-4 text-gray-500">
                No Image Available
              </div>
            )}
            {/* END OF NEW/IMPROVED IMAGE LOGIC */}
{car.isSold && (
  <div className="absolute top-0 left-0 w-full h-48 overflow-hidden pointer-events-none z-10">
    <div className="absolute bg-red-600 text-white font-extrabold text-4xl py-4 w-[200%] text-center rotate-[-45deg] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 shadow-xl tracking-widest">
      SOLD
    </div>
  </div>
)}
            {/* OLD SOLD BANNER
             {car.isSold && (
  <div className="absolute inset-0 flex items-center justify-center">
    <div className="bg-red-600 text-white text-4xl font-bold px-10 py-3 rotate-[-20deg]">
      SOLD
    </div>
  </div>
)} */}

            <div className="p-4">
              <h2 className="font-heading text-xl font-semibold mb-2">
                {car.title}
              </h2>
              <p className="font-body text-primary font-bold">${car.price}</p>
              {car.year && (
                <p className="font-body text-gray-600 text-xs">
                  Year: {car.year}
                </p>
              )}
              {car.make && (
                <p className="font-body text-gray-600 text-xs">
                  Make: {car.make}
                </p>
              )}
              {car.model && (
                <p className="font-body text-gray-600 text-xs">
                  Model: {car.model}
                </p>
              )}

              {/* Changed this to a Link so it navigates properly */}
              <Link
                to={`/cars/${car.slug.current}`}
                className="inline-block bg-secondary text-primary py-2 px-4 rounded-md hover:bg-secondary-dark mt-2 text-center"
              >
                View Details
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CarsForSalePage;
